import { IconChevronRight16, UIHeading3 } from '@cian/ui-kit';
import { FC } from 'react';
import clsx from 'clsx';

import * as style from './style.css';

interface IButtonProps {
  title: string;
  url: string;
  className: string;
  onClick: (buttonName: string) => void;
}

export const Button: FC<IButtonProps> = ({ title, url, className, onClick }) => {
  return (
    <a className={style['content']} href={url} onClick={() => onClick('download_app')}>
      <div className={clsx(style['icon'], style[className])}></div>
      <div className={style['text']}>
        <UIHeading3 color="white_100">{title}</UIHeading3>
      </div>
      <IconChevronRight16 color="white_100" />
    </a>
  );
};
